var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.step === 1)?_c('Waiting',{attrs:{"feedback":_vm.feedback}}):(_vm.step === 2)?_c('Error404'):_vm._e(),_c('invitation-error-modal',{ref:"invitationErrorModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }